import ImageWithValidate from '../../../../common/input/image-with-validate';
import { PlayFormData } from '../../types';

interface HeroImageInputProps {
  teamAbbrv: string;
  value: string;
  onChange: (value: string) => void;
}

export function HeroImageInput({ teamAbbrv, value, onChange }: HeroImageInputProps) {
  const handleValueChange = (name: keyof PlayFormData, newValue: string) => {
    if (name === 'heroImage') {
      onChange(newValue);
    }
  };

  return (
    <ImageWithValidate<PlayFormData>
      storagePath={`fotbollplay/${teamAbbrv}`}
      name="heroImage"
      value={value}
      onValue={handleValueChange}
    />
  );
}
